// SPDX-License-Identifier: AGPL-3.0-or-later

import {Routes} from '@app/app/Routes';
import {DiscoveryGuildHeader} from '@app/features/app/components/layout/DiscoveryGuildHeader';
import styles from '@app/features/app/components/layout/GuildLayout.module.css';
import {GuildSidebar} from '@app/features/app/components/layout/GuildSidebar';
import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {DiscoveryCompanionRecordsPage} from '@app/features/discovery/discovery/DiscoveryCompanionRecordsPage';
import {DiscoveryCompanionTalkPage} from '@app/features/discovery/discovery/DiscoveryCompanionTalkPage';
import {DiscoveryPage} from '@app/features/discovery/discovery/DiscoveryPage';
import {DiscoverySidebar} from '@app/features/discovery/discovery/DiscoverySidebar';
import Discovery from '@app/features/discovery/state/Discovery';
import * as RouterUtils from '@app/features/navigation/utils/RouterUtils';
import {useLocation, useParams} from '@app/features/platform/components/router/RouterReact';
import MobileLayout from '@app/features/ui/state/MobileLayout';
import {observer} from 'mobx-react-lite';
import {useEffect} from 'react';

export const DiscoveryLayout = observer(function DiscoveryLayout() {
	const mobileLayout = MobileLayout;
	const available = RuntimeConfig.discoveryAvailable;
	const location = useLocation();
	const {sessionId} = useParams() as {sessionId?: string};
	const companionRecordsSelected = Routes.isDiscoverCompanionsRoute(location.pathname);
	const companionTalkSelected = Routes.isDiscoverCompanionTalkRoute(location.pathname);
	const companionPageSelected = companionRecordsSelected || companionTalkSelected;
	useEffect(() => {
		if (!available) {
			RouterUtils.replaceWith(Routes.ME);
			return;
		}
		if (!companionPageSelected) {
			void Discovery.loadCategories();
			void Discovery.search({offset: 0});
		}
		return () => {
			if (!companionPageSelected) {
				Discovery.reset();
			}
		};
	}, [available, companionPageSelected]);
	if (!available) {
		return null;
	}
	const content = companionTalkSelected ? (
		<DiscoveryCompanionTalkPage data-flx="app.discovery-layout.companion-talk-page" />
	) : companionRecordsSelected ? (
		<DiscoveryCompanionRecordsPage
			sessionId={sessionId ?? null}
			data-flx="app.discovery-layout.companion-records-page"
		/>
	) : (
		<DiscoveryPage data-flx="app.discovery-layout.discovery-page" />
	);
	if (mobileLayout.enabled) {
		return content;
	}
	return (
		<div className={styles.guildLayoutContainer} data-flx="app.discovery-layout.guild-layout-container">
			<div className={styles.guildLayoutContent} data-flx="app.discovery-layout.guild-layout-content">
				<GuildSidebar
					header={<DiscoveryGuildHeader data-flx="app.discovery-layout.discovery-guild-header" />}
					content={<DiscoverySidebar data-flx="app.discovery-layout.discovery-sidebar" />}
					data-flx="app.discovery-layout.guild-sidebar"
				/>
				<div className={styles.guildMainContent} data-flx="app.discovery-layout.guild-main-content">
					{content}
				</div>
			</div>
		</div>
	);
});
